/*
 * @Author: liuyongjun
 * @Date: 2023-10-19 10:37:42
 * @LastEditors: liuyongjun
 * @LastEditTime: 2023-11-27 17:11:05
 * @PageTitle: 页面...
 * @Description: 描述...
 * @FilePath: \ejx-web\src\directive\permission\hasPermi.js
 */
/**
 * 操作权限处理
 * Copyright (c) 2019 ruoyi
 */
import store from '@/store'

export default {
  inserted(el, binding) {
    const { value } = binding
    const allPermission = '*:*:*'
    const {
      userInfoObj: { permissions = [] }
    } = store.getters

    if (value && value instanceof Array && value.length > 0) {
      const permissionFlag = value

      const hasPermissions = permissions.some(permission => {
        return allPermission === permission || permissionFlag.includes(permission)
      })

      if (!hasPermissions) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    } else {
      throw new Error(`请设置操作权限标签值`)
    }
  }
}
